import React from 'react';

const Dashboard: React.FC = () => {
	return <h2>Data not found</h2>;
};

export default Dashboard;
